export const getReportingCategories = (state) =>
  Object.values(state?.reportingCategories?.byId ?? {})

export const getIsReportingCategoriesLoading = (state) =>
  state?.reportingCategories?.isLoading ?? false

export const getCurrentReportingCategory = (
  state,
  reportingCategoryUuid
) =>
  state?.reportingCategories?.byId?.[reportingCategoryUuid] ??
  state?.reportingCategories?.pagination?.byId?.[
    reportingCategoryUuid
  ] ??
  {}

export const getPaginatedReportingCategories = (state) =>
  Object.values(state?.reportingCategories?.pagination?.byId ?? {})

export const getTotalReportingCategoriesCount = (state) =>
  state?.reportingCategories?.pagination?.total ?? 0
